// extracted by mini-css-extract-plugin
module.exports = {"ReadTime":"ReadingTime_ReadTime__1PJIU"};